import {Component, Inject, LOCALE_ID, OnInit, OnDestroy} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationService} from '@app/services/notification/notification.service';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {moment} from 'ngx-bootstrap/chronos/test/chain';
import {formatDate} from '@angular/common';
import {ProventumApiService} from '@app/services/proventum-api.service';
import {MatDialog} from '@angular/material/dialog';
import {NewTaskModalComponent} from '@components/my-web-desk/new-task-modal/new-task-modal.component';
import {MinutesOfMeetingComponent} from '@common-components/minutes-of-meeting/minutes-of-meeting.component';
import {Observable, Subscription} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {Router} from "@angular/router";
import {Globals} from "@app/services/globals.service";


@Component({
    selector: 'app-sidebar-content-notification-center',
    templateUrl: './sidebar-content-notification-center.component.html',
    styleUrls: ['./sidebar-content-notification-center.component.css']
})
export class SidebarContentNotificationCenterComponent implements OnInit, OnDestroy {
    datePipeString: string;
    private newMeetingSubscription: Subscription;


    constructor(private taskService: TaskService,
                private notifyService: NotificationService,
                @Inject(LOCALE_ID) private locale: string,
                public proventumApiService: ProventumApiService,
                private matDialog: MatDialog,
                private toastrService: ToastrService,
                private router: Router,
                private globals: Globals) {


        this.newMeetingSubscription = this.taskService.taskCreated.subscribe(result => {

            switch (result) {
                case 'meeting':
                    this.getTomorrowMeetings();
                    break;

                case 'note':
                    this.getNotes();
                    break;

                case 'reminder':
                    this.getReminders();
                    break;
            }
        });

    }


    liveItems = [];
    tomorrowMeetings = [];
    allNotes = [];
    allReminders = [];

    ngOnInit(): void {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        this.datePipeString = formatDate(date, 'dd.MM.yyyy', this.locale);
        this.getLiveViewItems();
        this.getTomorrowMeetings();
        this.getNotes();
        this.getReminders();

    }

    ngOnDestroy() {
        this.newMeetingSubscription.unsubscribe();
    }

    getLiveViewItems() {
        this.taskService.getRecentNotifications().subscribe(response => {
            if (response.type === 'success') {
                this.liveItems = response.data;
                let assignedArray = [];
                let users = this.globals.getAllUsers();
                this.liveItems.forEach((val, key) => {
                    let creatorData = users.find(item => item.id === val.user_id);
                    assignedArray.push(creatorData);
                    this.liveItems[key]['assigned'] = assignedArray;
                    assignedArray = [];

                });
            } else {
                this.notifyService.showError('Greška', response.message);
            }
        }, error => {
            console.log('error', error);
        });

    }

    getTomorrowMeetings() {
        this.taskService.getTomorrowMeetings().subscribe(response => {

            if (response.type === 'success') {
                this.tomorrowMeetings = response.result;
            } else {
                this.notifyService.showError('Greška', response.message);
            }
        }, error => {
            console.log(error);
        });

    }

    getNotes() {
        this.taskService.getNotes().subscribe(response => {

            if (response.type === 'success') {
                this.allNotes = response.result;
            } else {
                this.notifyService.showError('Greška', response.message);
            }
        }, error => {
            console.log(error);
        });

    }

    getReminders() {
        this.taskService.getReminders().subscribe(response => {
            if (response.type === 'success') {
                this.allReminders = response.result;
            } else {
                this.notifyService.showError('Greška', response.message);
            }
        }, error => {
            console.log(error);
        });

    }

    openModal() {
        this.matDialog.open(MinutesOfMeetingComponent, {
            disableClose: true,
            width: '60%',
            height: '100%',
        })
            .afterClosed().subscribe(response => {
            this.ngOnInit();
        });
    }

    closeNotification(id) {
        const response: Observable<any> = this.taskService.closeNotification(id);
        response.subscribe(data => {
            if (data.type !== 'success') {
                this.toastrService.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
            }
        });
    }

    navigateTo(id: string) {
        this.router.navigateByUrl('/view-task/' + id);
    }


}
